import { Component } from '@theme/component';

export class PairWithSlider extends Component {
  constructor() {
    super();
    this.slider = this.querySelector('[ref="slider"]');
    this.prevBtn = this.querySelector('[ref="prevBtn"]');
    this.nextBtn = this.querySelector('[ref="nextBtn"]');
  }

  connectedCallback() {
    super.connectedCallback();
    if (this.slider) {
      this.slider.addEventListener('scroll', this.#handleScroll.bind(this));
    }
  }

  prev() {
    if (!this.slider) return;
    const cards = this.slider.querySelectorAll('.pair-with__card');
    if (cards.length === 0) return;

    const cardWidth = cards[0].offsetWidth + 16;
    this.slider.scrollBy({ left: -cardWidth, behavior: 'smooth' });
  }

  next() {
    if (!this.slider) return;
    const cards = this.slider.querySelectorAll('.pair-with__card');
    if (cards.length === 0) return;

    const cardWidth = cards[0].offsetWidth + 16;
    this.slider.scrollBy({ left: cardWidth, behavior: 'smooth' });
  }

  #handleScroll() {
    if (!this.prevBtn || !this.nextBtn || !this.slider) return;

    const scrollLeft = this.slider.scrollLeft;
    const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;

    this.prevBtn.disabled = scrollLeft <= 0;
    this.nextBtn.disabled = scrollLeft >= maxScroll - 1;
  }
}

if (!customElements.get('pair-with-slider')) {
  customElements.define('pair-with-slider', PairWithSlider);
}
